import { render, staticRenderFns } from "./edit-actions.vue?vue&type=template&id=6490f99c&scoped=true&"
import script from "./edit-actions.vue?vue&type=script&lang=js&"
export * from "./edit-actions.vue?vue&type=script&lang=js&"
import style0 from "./edit-actions.vue?vue&type=style&index=0&id=6490f99c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../tmp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6490f99c",
  null
  
)

export default component.exports